import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrScalesIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M8 2.3C6 2.3 4 3.1 2.5 4.5C2.2 4.8 2.2 5.2 2.4 5.5L4.9 8.5C5.1 8.8 5.6 8.8 5.9 8.6C6.5 8.1 7.2 7.8 8 7.8C8.7 7.8 9.5 8.1 10.1 8.5C10.4 8.7 10.8 8.7 11.1 8.4L13.6 5.4C13.8 5.1 13.8 4.7 13.5 4.4C12 3.1 10 2.3 8 2.3ZM10.4 7.1C9.9 6.8 9.5 6.6 9 6.5L8.4 4.3C8.4 4.2 8.4 4.1 8.3 4.1C8.2 4.1 8.1 4 8 4C7.9 4 7.8 4 7.7 4.1C7.6 4.1 7.6 4.2 7.6 4.3L7 6.5C6.5 6.6 6 6.8 5.6 7L4 5.1C5.1 4.2 6.6 3.7 8 3.7C9.5 3.7 10.9 4.2 12 5.1L10.4 7.1ZM14 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V2C16 0.9 15.1 0 14 0ZM14.6 14C14.6 14.3 14.3 14.6 14 14.6H2C1.7 14.6 1.4 14.3 1.4 14V2C1.4 1.7 1.7 1.4 2 1.4H14C14.3 1.4 14.6 1.7 14.6 2V14Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrScalesIconComponent;
